import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { KtdGridModule } from '@katoid/angular-grid-layout';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallStateModule } from 'src/app/call-state/call-state.module';
import { TileWrapperModule } from '../tiles/containers/tile-wrapper/tile-wrapper.module';
import { AddDashboardTileModule } from './add-dashboard-tile/add-dashboard-tile.module';
import { AddDashboardDialogModule } from './containers/add-dashboard-dialog/add-dashboard-dialog.module';
import { DashboardHeaderBarModule } from './containers/dashboard-header-bar/dashboard-header-bar.module';
import { DashboardComponent } from './containers/dashboard.component';
import { DashboardEffects } from './state/dashboard.effects';
import * as fromDashboard from './state/dashboard.reducer';
import { DashboardViewComponent } from './views/dashboard-view.component';

@NgModule({
   declarations: [DashboardComponent, DashboardViewComponent],
   imports: [
      CommonModule,
      LcsLoadingOverlayModule,
      CallStateModule,
      LcsCallStatePipeModule,
      KtdGridModule,
      MatIconModule,
      MatButtonModule,
      DashboardHeaderBarModule,
      AddDashboardDialogModule,
      AddDashboardTileModule,
      TileWrapperModule,
      StoreModule.forFeature(fromDashboard.dashboardFeatureKey, fromDashboard.reducer),
      EffectsModule.forFeature([DashboardEffects]),
   ],
})
export class DashboardModule {}
